/*
 *  Performance Conventions
 *  ---
 *  Heavy calculations and ajax calls: Use throttle
 *  Animations and others: RAF
 */

main.window = (function () {
  var isResizing = false;
  var isScrolling = false;

  var init = function () {
    handleResize();
    handleScroll();
  };

  var handleResize = function () {
    window.addEventListener('resize', _handleResize, false);
  };

  var _handleResize = function () {
    if (!isResizing) {
      requestAnimationFrame(_updateResize);
    }
    isResizing = true;
  };

  var _updateResize = function () {
    isResizing = false;

    main.navigation.setA11YLabels();

    if (main.utils.viewport().width > 767) {
      main.navigation.close();
    }
  };

  var handleScroll = function () {
    window.addEventListener('scroll', _handleScroll, false);
  };

  var _handleScroll = function () {
    if (!isScrolling) {
      requestAnimationFrame(_updateScroll);
    }
    isScrolling = true;
  };

  var _updateScroll = function () {
    isScrolling = false;

    main.scroll.handleVisiblity();
  };

  return {
    init: init
  };
})();
